import { render, staticRenderFns } from "./storePrescriptRecord.vue?vue&type=template&id=77f5f232"
import script from "./storePrescriptRecord.vue?vue&type=script&lang=js"
export * from "./storePrescriptRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports